import React from "react";
import Textbox from "@material-ui/core/TextField";

export default props => (
    <Textbox {...props} classes={{ root: "form-control mb-3" }} />
);